import { Routes, Route, useNavigate } from "react-router-dom";
import Pages from "./pages";
import { useEffect } from "react";
import { getFromStorage } from "./helpers";
import { STORAGE_KEYS } from "./constants/storageKeys";
import { useAppDispatch } from "./hooks/store";
import { resetAuth, setCredentials } from "./reducers/authSlice";

const Routing = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    if (token && window.location.pathname === "/") {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: null,
        })
      );
      navigate("/dashboard", { replace: true });
    } else if (!token && window?.location?.pathname === "/") {
      dispatch(resetAuth());
      navigate("/", { replace: true });
    } else if (token) {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: null,
        })
      );
      navigate(window?.location?.pathname);
    } else {
      dispatch(resetAuth());
      navigate("/", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route path="/verify-otp" element={<Pages.Verification />} />
      <Route path="/dashboard" element={<Pages.Dashboard />} />
      <Route path="/my-profile" element={<Pages.MyProfile />} />
      <Route path="/users/individual" element={<Pages.Individuals />} />
      <Route path="/users/agent" element={<Pages.Dealers />} />
      <Route path="/users/agents/add" element={<Pages.AddSalariedAgents />} />
      <Route
        path="/users/agents/edit/:id"
        element={<Pages.AddSalariedAgents />}
      />
      <Route path="/users/company" element={<Pages.Stores />} />
      <Route path="/visa-type" element={<Pages.VisaTypes />} />
      <Route path="/visa-type/add" element={<Pages.AddVisaType />} />
      <Route path="/visa-type/edit/:id" element={<Pages.AddVisaType />} />
      <Route path="/manage-documents" element={<Pages.ManageDocuments />} />
      <Route path="/manage-documents/add" element={<Pages.AddDocuments />} />
      <Route
        path="/manage-documents/edit/:id"
        element={<Pages.AddDocuments />}
      />
      <Route path="/offer-letters" element={<Pages.ManageOfferLetters />} />
      <Route path="/offer-letters/add" element={<Pages.AddOfferLetter />} />
      <Route
        path="/offer-letters/edit/:id"
        element={<Pages.AddOfferLetter />}
      />
      <Route path="/manage-countries" element={<Pages.ManageCountries />} />
      <Route path="/manage-countries/add" element={<Pages.AddCountries />} />
      <Route
        path="/manage-countries/edit/:id"
        element={<Pages.AddCountries />}
      />
      <Route path="/manage-religions" element={<Pages.ManageReligions />} />
      <Route path="/manage-religions/add" element={<Pages.AddReligion />} />
      <Route
        path="/manage-religions/edit/:id"
        element={<Pages.AddReligion />}
      />
      <Route path="/manage-citizenship" element={<Pages.ManageCitizenship />} />
      <Route
        path="/manage-citizenship/add"
        element={<Pages.AddCitizenship />}
      />
      <Route
        path="/manage-citizenship/edit/:id"
        element={<Pages.AddCitizenship />}
      />
      <Route path="/manage-salaries" element={<Pages.ManageSalaries />} />
      <Route path="/manage-salaries/add" element={<Pages.AddSalaries />} />
      <Route path="/manage-salaries/edit/:id" element={<Pages.AddSalaries />} />
      <Route path="/manage-commission" element={<Pages.ManageCommission />} />
      <Route path="/manage-commission/add" element={<Pages.AddCommission />} />
      <Route
        path="/manage-commission/edit/:id"
        element={<Pages.AddCommission />}
      />
      <Route path="/permission-denied" element={<Pages.PermissionDenied />} />
      <Route
        path="/manage-applications"
        element={<Pages.ManageApplications />}
      />
      <Route
        path="/manage-applications/detail/:type/:id"
        element={<Pages.ApplicationDetails />}
      />
      <Route
        path="/manage-applications/edit/:type/:id"
        element={<Pages.EditApplication />}
      />
      <Route path="/manage-leaves" element={<Pages.ManageLeaves />} />
      <Route path="/manage-leaves/detail/:id" element={<Pages.LeaveDetail />} />
      <Route path="/manage-branches" element={<Pages.ManageBranches />} />
      <Route path="/manage-branches/add" element={<Pages.AddBranch />} />
      <Route path="/manage-branches/edit/:id" element={<Pages.AddBranch />} />
      <Route
        path="/manage-branches/detail/:id"
        element={<Pages.BranchDetail />}
      />
      <Route path="/add-employee" element={<Pages.AddEmployee />} />
      <Route path="/edit-employee/:id" element={<Pages.AddEmployee />} />
      <Route path="/customer-support" element={<Pages.CustomerSupport />} />
      <Route
        path="/customer-support/detail/:id"
        element={<Pages.CustomerSupportDetail />}
      />
      {/* payments */}
      <Route
        path="/manage-payments/payment-modes"
        element={<Pages.PaymentModes />}
      />{" "}
      <Route
        path="/manage-payments/payment-modes/add"
        element={<Pages.AddPaymentMode />}
      />
      <Route
        path="/manage-payments/payment-modes/edit/:id"
        element={<Pages.AddPaymentMode />}
      />
      <Route
        path="/manage-payments/payment-plans"
        element={<Pages.PaymentPlans />}
      />
      <Route
        path="/manage-payments/payment-plans/add"
        element={<Pages.AddPaymentPlan />}
      />
      <Route
        path="/manage-payments/payment-plans/edit/:id"
        element={<Pages.AddPaymentPlan />}
      />
      <Route path="/manage-payments/payments" element={<Pages.Payments />} />
      <Route
        path="/manage-payments/payments/view/:id"
        element={<Pages.PaymentDetail />}
      />
      <Route path="/reports" element={<Pages.Reports />} />
      <Route path="/user-management/roles" element={<Pages.Roles />} />
      <Route path="/user-management/user-list" element={<Pages.UserList />} />
      <Route path="/users/:type/:id" element={<Pages.ProfileDetail />} />
      <Route path="/users/:type/edit/:id" element={<Pages.EditProfile />} />
      <Route
        path="/manage-notifications"
        element={<Pages.ManageNotifications />}
      />
      <Route
        path="/recieved-notifications"
        element={<Pages.RecievedNotifications />}
      />
      <Route path="/manage-cms" element={<Pages.ManageCms />} />
      <Route path="/settings" element={<Pages.Settings />} />
    </Routes>
  );
};

export default Routing;
